import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_SHARE_LINK]: isLoading,
  [actionTypes.FETCH_SHARE_LINK_SUCCESS]: isEnding,
  [actionTypes.FETCH_SHARE_LINK_FAILURE]: isEnding,
});
